import { connect } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
var mapStateToProps = function (state) {
    var _a;
    return ({
        appId: ((_a = getPublicSession(state).appIds) === null || _a === void 0 ? void 0 : _a.facebookAppId) || '',
    });
};
var mapDispatchToProps = {
    attemptSocialLogin: attemptSocialLogin,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SocialButtonFacebook.container.js.map